import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from 'react-redux';
import { FileUpload } from 'primereact/fileupload';
import { Toast } from "primereact/toast";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; 
import CustomDropdown from '../../../../custom/customDropdown';

const FirmaUnos = () => {
  const { t } = useTranslation();

    const auth = useContext(AuthContext);
    const formRef = useRef(null);
    const toast = useRef(null);
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
    const [idForFiles, setIdForFiles] = useState(null)
    const [izabran, setIzabran] = useState(false)
    const [popuni, setPopuni] = useState(false)
    const [poruka, setPoruka] = useState(null)
    const [drzaveOptions, setDrzaveOptions] = useState(null)
    const [direktorOptions, setDirektorOptions] = useState(null)

    const [formSubmitted, setFormSubmitted] = useState(false);


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

///DATA
const [formDataCompanyGeneral, setFormDataCompanyGeneral] = useState({
  NazivFirme: '',
  PIB: '',
  MB: '',
  Drzava: null,
  Adresa: '',
  Broj: '',
  PostanskiBroj: '',
  Mesto: '',
  Direktor: null,
  Fiksni: '',
  Mobilni: '',
  Fax: '',
  Email: '',
  Email2: '',
  Memorandum: null
});

const [formDataCompanyMemo, setFormDataCompanyMemo] = useState({
  SifraDelatnosti: '',
  PDVbroj: '',
  Logo: null
});

/* Sekcija "Ministarstvo" — dokumenta koja firma dobija od Ministarstva.
   Zasebno stanje, ne u formDataCompanyMemo, jer je to grupa za radni nalog.
   Licenca drzi RELATIVNU PUTANJU koja vec stoji u bazi; novoizabrani fajl zivi
   u formDataCompanyGeneralFILES.uploadedFileLicenca dok se ne posalje. */
const [formDataCompanyMinistarstvo, setFormDataCompanyMinistarstvo] = useState({
  Licenca: null
});

///FILES
    const [formDataCompanyGeneralFILES, setFormDataCompanyGeneralFILES] = useState({
        uploadedFileMemorandum: null,
        uploadedFileLogo: null,
        uploadedFileLicenca: null
    });

    useEffect(()=>{
         let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            }
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/company", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                if(parsedData.CompanyDB) {
                                   popuniStavke(parsedData.CompanyDB)
                                }
                                setDrzaveOptions(parsedData.DrzaveOptions)      
                                setDirektorOptions(parsedData.DirektorOptions)
                                

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
    },[formSubmitted])

    const handleChangeDocUpload = (name, files) => {
   
        
        if (name === 'uploadedFileGeneral') {
            if (files) {
                // Ako je files niz, dodajemo sve fajlove, ako je jedan fajl, pravimo niz od njega
                const filesArray = Array.isArray(files) ? files : [files];
                setFormDataCompanyGeneralFILES(prev => ({ 
                    ...prev, 
                    [name]: [...prev[name], ...filesArray] 
                }));
            } else {
                // Ako je files null, resetujemo vrednost
                setFormDataCompanyGeneralFILES(prev => ({ ...prev, [name]: [] }));
            }
        } else {
            setFormDataCompanyGeneralFILES(prev => ({ ...prev, [name]: files }));
        } 
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataCompanyGeneral) {
        setFormDataCompanyGeneral(prev => ({ ...prev, [name]: value }));
        }
        if (name in formDataCompanyMemo) {
        setFormDataCompanyMemo(prev => ({ ...prev, [name]: value }));
        }
        if (name in formDataCompanyMinistarstvo) {
        setFormDataCompanyMinistarstvo(prev => ({ ...prev, [name]: value }));
        }
        
    };

    

   
    const popuniStavke = (data) => {
     
        const apiData = data[0]
    setFormDataCompanyGeneral({
        NazivFirme: apiData.NazivFirme || '',
        PIB: apiData.PIB || '',
        MB: apiData.MB || '',
        Drzava: apiData.Drzava || null,
        Adresa: apiData.Adresa || null,
        Broj: apiData.Broj || null,
        PostanskiBroj: apiData.PostanskiBroj || null,
        Mesto: apiData.Mesto || null,
        Direktor: apiData.Direktor || null,
        Fiksni: apiData.Fiksni || '',
        Mobilni: apiData.Mobilni || '',
        Fax: apiData.Fax || '',
        Email: apiData.Email || '',
        Email2: apiData.Email2 || '',
        Memorandum: apiData.Memorandum || ''
    });
    setFormDataCompanyMemo({
        SifraDelatnosti: apiData.SifraDelatnosti || '',
        PDVbroj: apiData.PDVbroj || '',
        Logo: apiData.Logo || ''
        });
    setFormDataCompanyMinistarstvo({
        Licenca: apiData.Licenca || ''
        });
    setIzabran(true)

};

    const handleUploadAndSaveFiles = async (id)=> {
              
                                            const formData = new FormData();
                                            formData.append("id", id);
                                            formData.append("entityType", "firma");


                                            Object.entries(formDataCompanyGeneralFILES).forEach(([key, value]) => {
                                                if (value) {
                                                    if (Array.isArray(value)) {
                                                        // Ako je vrednost niz fajlova (npr. uploadedFileGeneral)
                                                        value.forEach(file => {
                                                            formData.append(key, file); // NE koristi [index]!
                                                        });
                                                    } else {
                                                        // Ako je jedan fajl (npr. uploadedFileAPR)
                                                        formData.append(key, value);
                                                    }
                                                }
                                            });

                                       

                                            let requestOptionsFiles = {
                                                method: "POST",
                                                headers: {
                                                Authorization: "Bearer " + auth.token,
                                                },
                                                body: formData
                                            };
       
                                                await fetch(process.env.REACT_APP_BACKEND_URL + "/company/InsertCompanyFiles", requestOptionsFiles)
                                                .then(handleErrors)
                                                .then((data) => {
                                                    
                                                    setIdForFiles(false)
                                                    toast.current.show({
                                                    severity: "success",
                                                    summary: data.message,
                                                    life: 3000,
                                                      });

                                                })
                                                .catch((error) => {
                                                error.json().then((errorMessage) => {
                                                    toast.current.show({
                                                    severity: "error",
                                                    summary: "Error",
                                                    detail: errorMessage[0].message,
                                                    life: 3000,
                                                    });
                                                    console.log(errorMessage);
                                                });
                                            })
                                 
    }
const resetData = ()=> {
        setFormDataCompanyGeneral({
            NazivFirme: '',
            PIB: '',
            MB: '',
            Drzava: null,
            Adresa: '',
            Broj: '',
            PostanskiBroj: '',
            Mesto: '',
            Direktor: null,
            Fiksni: '',
            Mobilni: '',
            Fax: '',
            Email: '',
            Email2: '',
            Memorandum: null
                });
        setFormDataCompanyMemo({
        SifraDelatnosti: '',
        PDVbroj: '',
        Logo: null
        });
        setFormDataCompanyMinistarstvo({
        Licenca: null
        });
        setPoruka(false)

}
const resetDataFiles=()=>{
     setFormDataCompanyGeneralFILES({
        uploadedFileMemorandum: null,
        uploadedFileLogo: null,
        uploadedFileLicenca: null
    });

}


 const handleFormSubmit = (e) => {

                     e.preventDefault(); // bitno da ne submituje bez validacije
                setFormSubmitted(true)
            if (formRef.current && !formRef.current.checkValidity()) {
                formRef.current.reportValidity(); // prikazuje native browser poruke
                return;
            }
    handleUploadAndSave()
 }
        const handleUploadAndSave = () => {
       
            confirmDialog({
            message: "Jel ste sigurni da želite nastaviti sa unosom?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptInsert,
            reject: rejectInsert,
            });
        

    };

    const acceptInsert = async () => {

            //DATA
                const hasAnyValueGeneral = Object.values(formDataCompanyGeneral).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });

                const hasAnyValueMemo = Object.values(formDataCompanyMemo).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
            //FILES
                /* Bez ove provere izmena SAMO u sekciji Ministarstvo ne bi pokrenula snimanje. */
                const hasAnyValueMinistarstvo = Object.values(formDataCompanyMinistarstvo).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                return true;
                });

                const hasAnyValueGeneralFiles = Object.values(formDataCompanyGeneralFILES).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                return true;
                });
       
            if(izabran){
                 if(hasAnyValueGeneral || hasAnyValueMemo || hasAnyValueMinistarstvo){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: company.companyId,
                                formDataCompanyGeneral,
                                formDataCompanyMemo,
                                formDataCompanyMinistarstvo
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/company/UpdateCompany", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                console.log(data)
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima firme.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima firme.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesna_izmena_podataka_firme'),
                                life: 3000,
                                });
                                
                                setFormSubmitted(false)
                                
                               }
                                } 
                                
                                if((company.companyId) && (hasAnyValueGeneralFiles)) {
                                handleUploadAndSaveFiles(company.companyId)
                                }

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_firme_za_unos'),
                        life: 3000,
                    });
                }
           
           
            } else {
                

                if(hasAnyValueGeneral || hasAnyValueMemo || hasAnyValueMinistarstvo){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                formDataCompanyGeneral,
                                formDataCompanyMemo,
                                formDataCompanyMinistarstvo
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/company/InsertCompany", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                } 
 
                                setFormSubmitted(false)
             
                  

                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesan_unos_podataka_firme'),
                                life: 3000,
                                });
                                if((company.companyId) && (hasAnyValueGeneralFiles)) {
                                handleUploadAndSaveFiles(company.companyId)
                                }
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_firme_za_unos'),
                        life: 3000,
                    });
                }
            }

  };
    const rejectInsert = () => {
    console.log("Odbijen unos podataka!");
  };     



const invalidControl = (data) => {
  if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

  if (data && data != null && !Number(data)) {
    return data.length > 0 ? false : true;
  } else if (data != null && Number(data)) {
    return false;
  }
  return true;
};

    return (
         <div className="p-fluid grid formUnosZap">
      <div className="col-12">
        <Divider />

      </div>

      <Toast ref={toast} />
      <ConfirmDialog />

      <form autoComplete="off" ref={formRef}>
              <Card>
                <div className="gridLicni">
                  <div className="col-12 md:col-6">
                    <label htmlFor="NazivFirme">{t('admin.nazivFirme')}:</label>
                    <InputText
                      id="NazivFirme"
                      name="NazivFirme"
                      value={formDataCompanyGeneral.NazivFirme}
                      onChange={handleChange}
                      required
                      invalid={invalidControl(formDataCompanyGeneral.NazivFirme)}
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <label htmlFor="PIB">{t('admin.pib')}:</label>
                    <InputText
                      id="PIB"
                      name="PIB"
                      value={formDataCompanyGeneral.PIB}
                      onChange={handleChange}
                      required
                      invalid={invalidControl(formDataCompanyGeneral.PIB)}
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <label htmlFor="MB">{t('admin.maticniBroj')}:</label>
                    <InputText
                      id="MB"
                      name="MB"
                      value={formDataCompanyGeneral.MB}
                      onChange={handleChange}
                      required
                      invalid={invalidControl(formDataCompanyGeneral.MB)}
                    />
                  </div>

                  <div className="col-8 md:col-4">
                    <label htmlFor="Adresa">{t('admin.adresa')}:</label>
                    <InputText
                      id="Adresa"
                      name="Adresa"
                      value={formDataCompanyGeneral.Adresa}
                      onChange={handleChange}
                      required
                      invalid={invalidControl(formDataCompanyGeneral.Adresa)}
                    />
                  </div>

                  <div className="col-4 md:col-2">
                    <label htmlFor="Broj">{t('nova.broj')}:</label>
                    <InputText
                      id="Broj"
                      name="Broj"
                      value={formDataCompanyGeneral.Broj}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 md:col-4">
                    <label htmlFor="Mesto">{t('admin.mesto')}:</label>
                    <InputText
                      id="Mesto"
                      name="Mesto"
                      value={formDataCompanyGeneral.Mesto}
                      onChange={handleChange}
                      required
                      invalid={invalidControl(formDataCompanyGeneral.Mesto)}
                    />
                  </div>

                  <div className="col-6 md:col-3">
                    <label htmlFor="PostanskiBroj">{t('admin.postanskiBroj')}:</label>
                    <InputText
                      id="PostanskiBroj"
                      name="PostanskiBroj"
                      value={formDataCompanyGeneral.PostanskiBroj}
                      onChange={handleChange}
                      required
                      invalid={invalidControl(formDataCompanyGeneral.PostanskiBroj)}
                    />
                  </div>

                  <div className="col-6 md:col-3">
                    <label htmlFor="Drzava">{t('ture.drzava')}:</label>
                       <CustomDropdown
                            
                            options={drzaveOptions || []}
                            value={formDataCompanyGeneral.Drzava}
                            placeholder={t('admin.zemlja')} 
                            optionLabel="label"
                            id="Drzava"
                            name="Drzava"
                            onChange={handleChange}
                            required
                            invalid={invalidControl(formDataCompanyGeneral.Drzava)}/>
                  </div>

                  <div className="col-12 md:col-4">
                    <label htmlFor="Fiksni">{t('admin.fiksni')}:</label>
                    <InputText
                      id="Fiksni"
                      name="Fiksni"
                      value={formDataCompanyGeneral.Fiksni}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 md:col-4">
                    <label htmlFor="Mobilni">{t('admin.mobilni')}:</label>
                    <InputText
                      id="Mobilni"
                      name="Mobilni"
                      value={formDataCompanyGeneral.Mobilni}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 md:col-4">
                    <label htmlFor="Fax">{t('admin.fax')}:</label>
                    <InputText
                      id="Fax"
                      name="Fax"
                      value={formDataCompanyGeneral.Fax}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <label htmlFor="Email">{t('admin.emailAdresa')}:</label>
                    <InputText
                      id="Email"
                      name="Email"
                      value={formDataCompanyGeneral.Email}
                      onChange={handleChange}
                      required
                      invalid={invalidControl(formDataCompanyGeneral.Email)}
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <label htmlFor="Email2">{t('admin.email2')}:</label>
                    <InputText
                      id="Email2"
                      name="Email2"
                      value={formDataCompanyGeneral.Email2}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <label htmlFor="Direktor">{t('admin.direktor')}:</label>
                              <Dropdown 
                                                        id="Direktor" 
                                                        name="Direktor" 
                                                        required
                                                        invalid={invalidControl(formDataCompanyGeneral.Direktor)} 
                                                        value={formDataCompanyGeneral.Direktor} 
                                                        options={direktorOptions || []} 
                                                        onChange={handleChange}
                                                        placeholder={t('admin.phDirektora')}
                                                    />
                  </div>

                  {/* MEMORANDUM (fajl) */}
                  <div className="col-12 md:col-6">
                    <label>{t('admin.memorandum')}:</label>
                    {!formDataCompanyGeneralFILES.uploadedFileMemorandum ? (
                      <FileUpload
                        name="uploadedFileMemorandum"
                        mode="basic"
                        className={formDataCompanyGeneral.Memorandum ? 'green-btn' : ''}
                        customUpload={false}
                        auto={false}
                        chooseLabel="Izaberi"
                        accept=".pdf,.jpg,.png"
                        maxFileSize={5000000}
                        onSelect={(e) =>
                          handleChangeDocUpload("uploadedFileMemorandum", e.files?.[0] ?? null)
                        }
                      />
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Button
                          label={formDataCompanyGeneralFILES.uploadedFileMemorandum.name}
                          outlined
                          type="button"
                        />
                        <Button
                          icon="pi pi-times"
                          className="p-button-danger p-button-text p-button-rounded"
                          onClick={() =>
                            handleChangeDocUpload("uploadedFileMemorandum", null)
                          }
                          tooltip="Ukloni fajl"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Card>
              <Card>
                <div className="gridLicni">
                    <h3 style={{marginBottom: '0', display:'flex', justifyContent: 'center', alignItems: 'center'}}>Podaci za radni nalog</h3>
                  <div className="col-12 md:col-6">
                    <label htmlFor="SifraDelatnosti">{t('admin.sifraDelatnosti')}:</label>
                    <InputText
                      id="SifraDelatnosti"
                      name="SifraDelatnosti"
                      value={formDataCompanyMemo.SifraDelatnosti}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-12 md:col-6">
                    <label htmlFor="PDVbroj">{t('admin.pdvBroj')}:</label>
                    <InputText
                      id="PDVbroj"
                      name="PDVbroj"
                      value={formDataCompanyMemo.PDVbroj}
                      onChange={handleChange}
                    />
                  </div>

                  {/* MEMORANDUM (fajl) */}
                  <div className="col-12 md:col-6">
                    <label>{t('admin.logoRadniNalog')}:</label>
                    {!formDataCompanyGeneralFILES.uploadedFileLogo ? (
                      <FileUpload
                        name="uploadedFileLogo"
                        mode="basic"
                        className={formDataCompanyMemo.Logo ? 'green-btn' : ''}
                        customUpload={false}
                        auto={false}
                        chooseLabel="Izaberi"
                        accept=".jpg,.png"
                        maxFileSize={5000000}
                        onSelect={(e) =>
                          handleChangeDocUpload("uploadedFileLogo", e.files?.[0] ?? null)
                        }
                      />
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Button
                          label={formDataCompanyGeneralFILES.uploadedFileLogo.name}
                          outlined
                          type="button"
                        />
                        <Button
                          icon="pi pi-times"
                          className="p-button-danger p-button-text p-button-rounded"
                          onClick={() =>
                            handleChangeDocUpload("uploadedFileLogo", null)
                          }
                          tooltip="Ukloni fajl"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Card>

              {/* ── Ministarstvo ───────────────────────────────────────────────
                  Dokumenta koja firma dobija od Ministarstva. Licenca je prvi;
                  sekcija je namerno zasebna kartica, da se dopunjava bez diranja
                  podataka za radni nalog. */}
              <Card>
                <div className="gridLicni">
                  <h3 style={{marginBottom: '0', display:'flex', justifyContent: 'center', alignItems: 'center'}}>{t('nav.ministarstvo')}</h3>

                  {/* LICENCA (fajl) */}
                  <div className="col-12 md:col-6">
                    <label>{t('admin.licenca')}:</label>
                    {!formDataCompanyGeneralFILES.uploadedFileLicenca ? (
                      <FileUpload
                        name="uploadedFileLicenca"
                        mode="basic"
                        /* zeleno = fajl vec postoji u bazi */
                        className={formDataCompanyMinistarstvo.Licenca ? 'green-btn' : ''}
                        customUpload={false}
                        auto={false}
                        chooseLabel="Izaberi"
                        accept=".pdf,.jpg,.png"
                        maxFileSize={5000000}
                        onSelect={(e) =>
                          handleChangeDocUpload("uploadedFileLicenca", e.files?.[0] ?? null)
                        }
                      />
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Button
                          label={formDataCompanyGeneralFILES.uploadedFileLicenca.name}
                          outlined
                          type="button"
                        />
                        <Button
                          icon="pi pi-times"
                          className="p-button-danger p-button-text p-button-rounded"
                          onClick={() =>
                            handleChangeDocUpload("uploadedFileLicenca", null)
                          }
                          tooltip="Ukloni fajl"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Card>

        <div className="formUnosZap buttonUnosZap">
          <button type="submit" onClick={handleFormSubmit} className="btn btn-success">
            {izabran ? "SAČUVAJ" : "UNOS"}
          </button>
        </div>
      </form>
    </div>
    );
};

export default FirmaUnos;